const LogoVertical = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="140"
      fill="none"
      viewBox="0 0 287 370"
    >
      <g
        fill="#1A5CAA"
        fillRule="evenodd"
        clipRule="evenodd"
        filter="url(#filter0_d_173_17)"
      >
        <path d="M50.25 290.827H63.09v-1.658l-26.503-56.791h-5.71L4.207 289.169v1.658h12.917l16.563-39.16 16.563 39.16zM81.906 232.378h-12.53v58.439h12.53v-58.439zm2.563 58.439h21.829v-11.188h-21.83v11.188zM156.657 290.827h12.841v-1.658l-26.503-56.791h-5.709l-26.673 56.791v1.658h12.927l16.554-39.16 16.563 39.16zM208.749 269.58c6.67-3.25 10.42-9.748 10.42-17.16 0-10.332-7.255-19.994-20.586-19.994-8.338-.085-16.592 0-24.92 0v58.325h12.332V243.35h12.503c5.333 0 8.583 3.918 8.583 8.835.085 5.001-3.335 9.078-8.583 9.078h-9.94v10.247h8.027l12.003 19.251h13.332v-1.752l-13.171-19.411v-.018zM255.103 260.105L231.7 232.378h-4.579v58.449h12.493v-31.551l14.66 18.309h1.582l14.651-18.309v31.551H283v-58.449h-4.494l-23.403 27.727z"></path>
        <path d="M25.66 281.305h15.978l-7.99-9.456-7.989 9.456zM132.066 281.305h15.979l-7.989-9.456-7.99 9.456z"></path>
      </g>
      <g
        fill="#1A5CAA"
        fillRule="evenodd"
        clipRule="evenodd"
        filter="url(#filter1_d_173_17)"
      >
        <path d="M68.735 327.764l-5.352-10.878-7.066-12.093H43.24v1.79l19.568 32.304v22.735H74.99v-22.735l19.494-32.304v-1.79H81.567l-6.821 11.688-5.597 11.283h-.414zM152.36 315.351h26.88v-10.558h-42.067v10.558h15.187zm0 2.486v43.785h11.777v-43.785H152.36zM221.1 304.793h-34.841v56.829h35.491v-11.038h-23.224v-12.997h16.045v-10.633h-16.045v-11.528H221.1v-10.633zM255.8 331.663l-22.819-27.03h-4.466v56.989h12.182v-30.769l14.293 17.856h1.535l14.293-17.856v30.769H283v-56.989h-4.381l-22.819 27.03zM4.206 353.305l6.435-7.28c.81 1.997 2.12 3.57 3.91 4.7 1.8 1.149 3.825 1.723 6.068 1.723 2.713 0 4.861-.64 6.434-1.93 1.574-1.272 2.356-3.005 2.356-5.171 0-2.561-2.629-5.104-7.877-7.638-1.705-.819-3.043-1.478-4.023-1.996-4.73-2.468-8.008-4.879-9.836-7.224-1.818-2.354-2.723-5.161-2.723-8.41 0-4.455 1.762-8.119 5.295-10.982 3.534-2.872 8.122-4.313 13.765-4.313 3.279 0 6.105.584 8.49 1.723 2.373 1.131 4.474 2.939 6.293 5.369l-6.84 6.536c-.81-1.573-1.894-2.75-3.232-3.523-1.347-.781-2.968-1.177-4.852-1.177-2.299 0-4.136.584-5.55 1.724-1.403 1.13-2.11 2.627-2.11 4.454 0 2.854 2.79 5.463 8.348 7.836 1.112.471 1.969.829 2.544 1.111 4.588 2.091 7.99 4.455 10.194 7.092 2.195 2.637 3.307 5.642 3.307 9.013 0 5.067-1.724 9.117-5.201 12.131-3.458 3.023-8.112 4.53-13.953 4.53-4.136 0-7.679-.707-10.647-2.148-2.949-1.422-5.163-3.484-6.614-6.168l.02.018zM96.02 353.305l6.434-7.28c.811 1.997 2.12 3.57 3.91 4.7 1.8 1.149 3.825 1.723 6.068 1.723 2.713 0 4.861-.64 6.435-1.93 1.573-1.272 2.355-3.005 2.355-5.171 0-2.561-2.628-5.104-7.876-7.638-1.706-.819-3.043-1.478-4.023-1.996-4.73-2.468-8.009-4.879-9.836-7.224-1.819-2.354-2.723-5.161-2.723-8.41 0-4.455 1.762-8.119 5.295-10.982 3.533-2.872 8.121-4.313 13.765-4.313 3.278 0 6.105.584 8.488 1.723 2.375 1.131 4.476 2.939 6.294 5.369l-6.84 6.536c-.81-1.573-1.894-2.75-3.232-3.523-1.347-.781-2.967-1.177-4.861-1.177-2.299 0-4.136.584-5.549 1.724-1.404 1.13-2.111 2.627-2.111 4.454 0 2.854 2.789 5.463 8.348 7.836 1.111.471 1.969.829 2.543 1.111 4.589 2.091 7.99 4.455 10.195 7.092 2.195 2.637 3.307 5.642 3.307 9.013 0 5.067-1.725 9.117-5.201 12.131-3.458 3.023-8.112 4.53-13.953 4.53-4.137 0-7.679-.707-10.647-2.148-2.949-1.422-5.163-3.484-6.614-6.168l.028.018z"></path>
      </g>
      <g filter="url(#filter2_d_173_17)">
        <path
          fill="url(#paint0_linear_173_17)"
          fillRule="evenodd"
          d="M144.113 0l20.905 36.964L89.054 171.24h26.293l62.83-111.036L261.226 207H156.444l20.231-35.76h22.394l-20.814-36.783L137.21 207H27L144.113 0z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_173_17"
          width="286.794"
          height="66.448"
          x="0.206"
          y="232.378"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_173_17"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_173_17"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_d_173_17"
          width="286.813"
          height="64.988"
          x="0.187"
          y="304.633"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_173_17"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_173_17"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter2_d_173_17"
          width="242.226"
          height="215"
          x="23"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_173_17"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_173_17"
            result="shape"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_173_17"
          x1="144.113"
          x2="144.113"
          y1="171.253"
          y2="-1.631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#124B93"></stop>
          <stop offset="0.18" stopColor="#2868A7"></stop>
          <stop offset="0.56" stopColor="#549FCF"></stop>
          <stop offset="0.85" stopColor="#6FC1E7"></stop>
          <stop offset="1" stopColor="#7ACFF1"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoVertical;
